module.exports = __webpack_public_path__ + "img/奖章5级@3x.400db948.png";